/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
import { IpServiceDetApi } from '../api/ipservicedet.api';
import { switchMap, map } from 'rxjs/operators';
import { IpServiceDet,IpServiceDetData } from '../../../interfaces/Ip/ipservicedet';

@Injectable()
export class IpServiceDetService extends IpServiceDetData {

  constructor(private api: IpServiceDetApi) {
    super();
  }


  list(url: string): Observable<IpServiceDet[]> {
    return this.api.list(url);
  }

  getById(url: string): Observable<IpServiceDet>{
      return this.api.getById(url);
  }

  create(url: string, data: IpServiceDet): Observable<IpServiceDet[]> {
    return this.api.add(url,data);
  }

  createRoomRent(url: string, data: any): Observable<any> {
    return this.api.createRoomRent(url,data);
  }
  updateRoomRent(url: string, data: any): Observable<any> {
    return this.api.updateRoomRent(url,data);
  }


  update(url: string, data: IpServiceDet): Observable<IpServiceDet> {
    return this.api.update(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
   searchByType(url: string): Observable<any>{

    return this.api.searchByType(url);

  }

  searchByWardPrice(url: string, data: any): Observable<any> {
    return this.api.searchByWardPrice(url,data);
  }
  postmeth(url: string, data: any): Observable<any> {
    return this.api.postmeth(url,data);
  }
  deleteByIds(url: string, ids: string[]): Observable<any> {
    return this.api.deleteByIds(url, ids);
  }
}
